export function getPluralForm(
  number: number,
  locale = "ru",
): Intl.LDMLPluralRule {
  const pluralRules = new Intl.PluralRules(locale);
  return pluralRules.select(number);
}

export const formatTimeUntilExpiry = (
  expiryDate: string,
): { days: number; hours: number } => {
  const now = new Date();
  const expiry = new Date(expiryDate);
  const diffInMs = expiry.getTime() - now.getTime();

  if (diffInMs <= 0) {
    return { days: 0, hours: 0 };
  }

  const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60));
  const days = Math.floor(diffInHours / 24);
  const hours = diffInHours % 24;

  return { days, hours };
};

const getPluralWord = (
  number: number,
  forms: {
    one: string;
    few: string;
    many: string;
    other: string;
  },
): string => {
  const plural = getPluralForm(number);

  switch (plural) {
    case "one":
      return forms.one;
    case "few":
      return forms.few;
    case "many":
      return forms.many;
    default:
      return forms.other;
  }
};

export const formatExpiryText = (
  expiryDate: string,
  translations: {
    expiresIn: string;
    days: {
      one: string;
      few: string;
      many: string;
      other: string;
    };
    hours: {
      one: string;
      few: string;
      many: string;
      other: string;
    };
    expired: string;
    expiresToday: string;
  },
): string => {
  const { days, hours } = formatTimeUntilExpiry(expiryDate);

  if (days === 0 && hours === 0) {
    return translations.expired;
  }

  const parts: string[] = [];

  if (days > 0) {
    parts.push(`${days} ${getPluralWord(days, translations.days)}`);
  }

  if (hours > 0) {
    parts.push(`${hours} ${getPluralWord(hours, translations.hours)}`);
  }

  if (parts.length === 0) {
    return translations.expiresToday;
  }

  return `${translations.expiresIn} ${parts.join(" ")}`;
};
